// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PurchaseOrderInvoice } from './purchase-order-invoice';
import { PurchaseOrderLineItem } from './purchase-order-line-item';
import { PurchaseOrderLineReceiving } from './purchase-order-line-receiving';

/// <code-import> Place custom imports between <code-import> tags
import { Utility } from '../utility';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PurchaseOrderInvoiceLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get invoiceLineTotal() {
        return Utility.round(this.quantity * this.cost, 2);
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  cost!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  purchaseOrderInvoiceId!: number;
  purchaseOrderLineItemId?: number;
  purchaseOrderLineReceivingId?: number;
  quantity!: number;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  purchaseOrderInvoice!: PurchaseOrderInvoice;
  purchaseOrderLineItem!: PurchaseOrderLineItem;
  purchaseOrderLineReceiving!: PurchaseOrderLineReceiving;
}

